import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Filter } from 'components/molecules/filters/types';
import { FilterableField } from 'components/organisms/tasks/fields';
import { GetFilterOperationTypeOptions } from 'components/organisms/tasks/filter-box/advanced';
import { defaultFilter } from '../filters/utils';
import { FilterDrawerBadges } from './badges';
import { FDrawer } from './drawer';
import { FilterTrigger } from './styles';

interface Props {
  fields: FilterableField[];
  onSubmit: (filter: Filter) => void;
  filter?: Filter;
  showMinimumBadges?: boolean;
  getFilterOperationTypeOptions?: GetFilterOperationTypeOptions;
}

export const FilterDrawer: FC<Props> = ({
  fields,
  filter = defaultFilter,
  onSubmit,
  showMinimumBadges,
  getFilterOperationTypeOptions,
}) => {
  const [showConditionsDrawer, setShowConditionsDrawer] = useState(false);
  const onCloseDrawer = () => {
    setShowConditionsDrawer(false);
  };

  const onFilterDrawerSubmit = (_filter: Filter) => {
    onCloseDrawer();
    onSubmit(_filter);
  };

  return (
    <>
      <FDrawer
        fields={fields}
        filter={filter}
        onSubmit={onFilterDrawerSubmit}
        title={
          filter.criteria.length ? (
            <FormattedMessage id="edit_conditions" />
          ) : (
            <FormattedMessage id="add_conditions" />
          )
        }
        visible={showConditionsDrawer}
        onClose={onCloseDrawer}
        getFilterOperationTypeOptions={getFilterOperationTypeOptions}
      />
      <FilterDrawerBadges
        filter={filter}
        showMinimumBadges={showMinimumBadges}
      />
      <FilterTrigger type="link" onClick={() => setShowConditionsDrawer(true)}>
        {filter.criteria.length ? (
          <FormattedMessage id="edit_conditions" />
        ) : (
          <FormattedMessage id="add_conditions" />
        )}
      </FilterTrigger>
    </>
  );
};
